import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { BREAKPOINTS, COLORS_BASE } from '../../utils/consts';
import { PAGE_TITLE } from '../../utils/text';

function AppName() {
  return (
      <AppNameStyle>
        <Link to="/">
          <BlitzStyle src='/logos/lesotho-blitz.svg' alt="Portal Logo"/>
        </Link>
        <TitleSpanStyle>{PAGE_TITLE}</TitleSpanStyle>
      </AppNameStyle>
  )
}

export default AppName;

const AppNameStyle = styled.h1<{}>(() => `
height: 100%;
display: flex;
align-items: center;
min-width: 0;
> svg {
  padding: 0 10px 0 0;
}
`)

const TitleSpanStyle = styled.span<{}>(() => `
font-size: 14px;
font-weight: 800;
width: 10rem;
margin-left: 0.5rem;
color: ${COLORS_BASE.BRAND.MAIN}

@media (max-width: ${BREAKPOINTS.MOBILE}) {
  width: auto;
  max-width: 10rem;
  font-size: 12px;
  line-height: 1.2;
}
`)


export const BlitzStyle = styled.img`
width: 2.8rem;
object-fit: contain;
padding: 1rem;

@media (max-width: ${BREAKPOINTS.MOBILE}) {
  width: 2.2rem;
  padding: 0.5rem;
}
`